import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CompanyRouteService } from '@shared/services';
import { BaseModule } from '../../shared/base.module';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { SelectListItem } from '../../shared/models';

@Component({
  selector: 'app-company-selector',
  templateUrl: './company-selector.component.html',
  styleUrls: ['./company-selector.component.scss'],
  standalone: true,
  imports: [
    BaseModule,
  ]
})
export class CompanySelectorComponent {
  constructor(
    public companyRouteService: CompanyRouteService,
    public translateService: TranslateService,
    public router: Router,
  ) { }

  public companyList: SelectListItem[] = [];

  ngOnInit() {
    this.companyRouteService.getAllCompanyIds().subscribe({
      next: (list) => {
        let defaultItem = list.find(item => item.isDefault == true || item.isSelected == true);
        if (defaultItem && defaultItem.id) {
          this.navigateToRoute(defaultItem.id);
        }
        if (list?.length == 1 && list[0]?.id) {
          this.navigateToRoute(list[0].id);
        }
        else {
          this.companyList = [...list];
        }
      }
    })
  }

  onSelectionChanged(event: MatSelectChange) {
    if (event.value) {
      this.navigateToRoute(event.value);
    }
  }

  navigateToRoute(companyId) {
    this.router.navigate([`/${companyId}/storage`]);
  }
}
